<!-- <section id="welcomeSection" class="summary-section">

  <div class="welcome-wrapper">

    <mat-card class="welcome-info-card">

      <mat-chip-set>
        <mat-chip class="welcome-info-chip" [disabled]="true">{{today}}</mat-chip>
      </mat-chip-set>

      <div class="welcome-info-text-wrapper">
        <span id="welcomeTextLine" class="welcome-info-card-text">Welcome, <span class="welcome-info-card-strong">{{ auth.displayName() }}</span></span>
        <span class="welcome-info-card-text">Company: <span class="welcome-info-card-strong">{{ auth.processorLabel() }}</span></span>
        <span class="welcome-info-card-text">Sites in this report: <span class="welcome-info-card-strong">{{ sitesLabel() }}</span></span>
      </div>

    </mat-card>

    <mat-card id="bannerPlaceholder" class="summary-chart-card">

    </mat-card>

  </div>

</section> -->

<section id="summaryInfoSection" class="summary-section">

  <mat-card id="firstSummaryChartCard" class="summary-chart-card">

    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title summary-chart-card-title">Daily Activity - Last 7 Days</span>
      </div>
      <div class="left">
        <button mat-button color="primary" routerLink="/activity-by-date">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Activity By Date' Report
        </button>
      </div>
    </mat-toolbar>

    <mat-card-content class="activity-by-date-summary-card-content">

      <p class="activity-by-date-summary-card-text">Vehicle processed by day and by status (deletion outcome)</p>

      @if (chartLoading) {
        <div class="loader-wrapper">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else {
        <div class="activity-by-date-summary-chart-conainer ">
          <canvas
            baseChart
            [type]="stackedBarChartType"
            [data]="stackedBarChartData()"
            [options]="stackedBarChartOptions"
            [plugins]="chartPlugins">
          </canvas>
        </div>

        <div class="chart-legend" aria-label="Totals by status">
          @for (entry of chartLegend(); track entry.status) {
            <div class="chart-legend-chip">
              <span
                class="chart-legend-count"
                [style.background-color]="entry.color"
                [style.color]="entry.textColor">{{ entry.total }}</span>
              <span class="chart-legend-label">{{ entry.status }}</span>
            </div>
          }
        </div>
      }

    </mat-card-content>

    <!-- <mat-card-actions>
      <button mat-button color="primary" routerLink="/activity-by-date">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Activity By Date' Report
        </button>
    </mat-card-actions> -->

  </mat-card>

  <mat-card id="unprocessedVsProcessedSummaryCard" class="summary-chart-card">

    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title summary-chart-card-title">
          Unprocessed Inventory - Today
          @if (auth.businessType() == 'Dealer') {
            <span class="chart-exception-title">*</span>
          }
        </span>
      </div>
      <!-- <div class="left">
        <button
          mat-button
          color="primary">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Inventory Unprocessed' Report
        </button>
      </div> -->
    </mat-toolbar>

    <mat-card-content>

      <!-- <span>Count unprocessed vehicles on your lot(s) vs total inventory (based on last inventory feed transmitted by your provider)
      </span> -->

      <span>Count of unprocessed vehicles on your lot(s) (based on last inventory feed transmitted by your provider)
      </span>

      @if (auth.businessType() == 'Dealer') {
        
        <span class="chart-exception-text">*Pre-owned inventory for sale only. Excludes new vehicles and loaners.</span>

        <!-- <div class="chart-exception-warn-text-wrapper">
          <mat-icon>warning</mat-icon>
          <span class="chart-exception-warn-text">*Showing Used vehicles only. <br> *New/Loaner vehicles are excluded from this report.</span>
        </div> -->

        }

      @if (unprocessedVsProcessedCountsLoading) {
        <div class="loader-wrapper">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (inventory().total) {

        <!-- <p class="inventory-total">Total Current Inventory: {{ inventoryTotalLabel() }}</p> -->

        <!-- <mat-card class="inventory-total-card">

          <span class="inventory-total-hero">

            <span class="inventory-total">{{inventoryTotalLabel()}} </span>

            <span class="inventory-total-label">{{inventoryTotalLabel() == '1' ? 'vehicle' : 'vehicles'}}</span>

          </span>

          <span class="inventory-total-text">Total Current Inventory</span>

        </mat-card> -->

        <div class="inventory-wrapper">

          <!-- <div class="inventory-chart-container">
            <canvas
              baseChart
              [type]="pieChartType"
              [data]="inventoryChartData()"
              [options]="inventoryChartOptions()"
              [plugins]="inventoryChartPlugins">
            </canvas>
          </div> -->

          <!-- <div class="inventory-legend">
            @for (entry of inventoryLegend(); track entry.label) {
              <div class="inventory-legend-row">
                <span class="inventory-legend-swatch" [style.background-color]="entry.color">
                </span>
                <span>{{entry.label}}</span>
              </div>
            }
          </div> -->
          
          <div class="inventory-legend-swatch-card-container">
            @for (entry of inventoryLegend(); track entry.label) {

              <!-- <mat-card class="inventory-legend-swatch-card" [style.border-color]="entry.color">

                <span class="inventory-legend-swatch-rich" [style.background-color]="entry.color" [style.color]="entry.fontColor">

                  <span class="swatch-hero">
                    
                    <span class="inventory-legend-swatch-share">{{entry.share}}% </span>
                    
                    <span class="inventory-legend-swatch-label">{{entry.label}}</span>

                  </span>

                  <mat-divider style="padding-bottom:0.5em"></mat-divider>
                  
                  <span class="inventory-legend-swatch-count">{{entry.count == '1' ? entry.count + ' vehicle' :  entry.count + ' vehicles'}} </span>

                </span>

                <span class="inventory-legend-swatch-text" [style.color]="entry.color">{{entry.text}}</span>

              </mat-card> -->

              <mat-card class="inventory-legend-swatch-card" [style.border-color]="entry.color">

                <span class="inventory-legend-swatch-rich" [style.background-color]="entry.color" [style.color]="entry.fontColor">

                  <span class="swatch-hero">
                    
                    <span class="inventory-legend-swatch-count">{{entry.count}}</span>
                    
                    <span class="inventory-legend-swatch-label">{{entry.count == '1' ? 'vehicle ' + entry.label : 'vehicles ' + entry.label}} </span>

                  </span>

                </span>

                <span class="inventory-legend-swatch-text" [style.color]="entry.color">{{entry.text}}</span>

              </mat-card>
            }
          </div>

        </div>

      } @else {
        <p class="inventory-empty">No inventory reported.</p>
      }

    </mat-card-content>

    <mat-card-actions>
      <button mat-button color="primary" routerLink="/inventory-unprocessed">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Inventory Unprocessed' Report
        </button>
    </mat-card-actions>

  </mat-card>

  <mat-card id="soldUnprocessedSummaryCard" class="summary-chart-card">

    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title summary-chart-card-title">
          Sold Unprocessed
          @if (auth.businessType() == 'Dealer') {
            <span class="chart-exception-title">*</span>
          }
        </span>
      </div>
      <!-- <div class="left">
        <button mat-button color="primary">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Sold Unprocessed' Report
        </button>
      </div>  -->
    </mat-toolbar>

    <mat-card-content>

      <span>Estimated Used vehicles delivered to a customer where a data deletion was not performed — highest-risk exposure.</span>

      @if (auth.businessType() == 'Dealer') {

        <span class="chart-exception-text">*Pre-owned inventory for sale only. Excludes new vehicles and loaners.</span>

        <!-- <div class="chart-exception-warn-text-wrapper">
          <mat-icon>warning</mat-icon>
          <span class="chart-exception-warn-text">*Showing Used vehicles only. <br> *New/Loaner vehicles are excluded from this report.</span>
        </div> -->

      }

      @if (soldUnprocessedCountsLoading) {
        <div class="loader-wrapper">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (soldUnprocessedCounts != undefined) {
        <div class="sold-unprocessed-counts-wrapper">

          <div class="sold-unprocessed-counts-container">

            <mat-card class="sold-unprocessed-count-card">
              <!-- <mat-card-content> -->

                <div class="sold-unprocessed-count-hero">
                  <span class="sold-unprocessed-count-number">{{soldUnprocessedCounts.last24Hours}}</span>
                  <span class="sold-unprocessed-count-unit-text">sold unprocessed</span>
                </div>

                <div class="sold-unprocessed-count-title-container">
                  <span class="sold-unprocessed-count-title">
                    in the last 24 hours
                  </span>
                </div>

                <!-- <span class="sold-unprocessed-count-subtitle">
                  were sold without deleting data
                </span> -->
              <!-- </mat-card-content> -->
            </mat-card>

            <!-- <span class="sold-unprocessed-count-title">
              last 24 hours
            </span> -->

          </div>

          <div class="sold-unprocessed-counts-container">

            <mat-card class="sold-unprocessed-count-card">
              <!-- <mat-card-content> -->

                <div class="sold-unprocessed-count-hero">
                  <span class="sold-unprocessed-count-number">{{soldUnprocessedCounts.last7Days}}</span>
                  <span class="sold-unprocessed-count-unit-text">sold unprocessed</span>
                </div>

                <div class="sold-unprocessed-count-title-container">
                  <span class="sold-unprocessed-count-title">
                    in the last 7 days
                  </span>
                </div>

                <!-- <span class="sold-unprocessed-count-subtitle">
                  were sold without deleting data
                </span> -->
              <!-- </mat-card-content> -->
            </mat-card>

            <!-- <span class="sold-unprocessed-count-title">
              last 7 days
            </span> -->

          </div>

          <div class="sold-unprocessed-counts-container">

            <mat-card class="sold-unprocessed-count-card">
              <!-- <mat-card-content> -->

                <div class="sold-unprocessed-count-hero">
                  <span class="sold-unprocessed-count-number">{{soldUnprocessedCounts.last30Days}}</span>
                  <span class="sold-unprocessed-count-unit-text">sold unprocessed</span>
                </div>

                <div class="sold-unprocessed-count-title-container">
                  <span class="sold-unprocessed-count-title">
                    in the last 30 days
                  </span>
                </div>

                <!-- <span class="sold-unprocessed-count-subtitle">
                  were sold without deleting data
                </span> -->
              <!-- </mat-card-content> -->
            </mat-card>

            <!-- <span class="sold-unprocessed-count-title">
              last 30 days
            </span> -->

          </div>

        </div>

      }

    </mat-card-content>

    <mat-card-actions>
      <button mat-button color="primary" routerLink="/sold-unprocessed">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Sold Unprocessed' Report
        </button>
    </mat-card-actions>

  </mat-card>

</section>
